export default __webpack_public_path__ + "static/media/pathways_logo.ae0e4717.svg";